import axios from "axios";
import { url } from "../baseUrl";

export const ContactStore = {
  actions: {
    sendHelp(data) {
      let auth_token = localStorage.getItem("auth_token");
      return new Promise((resolve, reject) => {
        axios({
          url: url.baseUrl + "/info/sendhelp/",
          headers: {
            Authorization: "Token " + auth_token
          },
          data: {
            name: data.name,
            email: data.email,
            topic: data.topic,
            message: data.message
          },
          method: "POST"
        })
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};
